import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';

import rootReducers from './reducers';
import storage from 'redux-persist/lib/storage';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: hardSet,
  // blacklist: ['menuPRTR']
  // whitelist: ['auth']
};
const persistedReducer = persistReducer(persistConfig, rootReducers);

const middlewares = [];
if (process.env.NODE_ENV === 'development') {
  // middlewares.push(createLogger());
}

middlewares.push(thunk);

export const store = createStore(
  persistedReducer,
  undefined,
  composeWithDevTools(applyMiddleware(...middlewares))
);

export const persistor = persistStore(store);



// WEBPACK FOOTER //
// ./src/@redux/index.js